module.exports = __webpack_public_path__ + "assets/no-pro-licence.c4307410.svg";